import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import store from '../store'

const routes = [
  { path: '/login', name: 'login', meta: { title: 'Login', public: true }, component: () => import('../views/LoginView.vue') },
  { path: '/', name: 'dashboard', meta: { title: 'Dashboard', hideTopbar: true }, component: () => import('../views/DashboardView.vue') },
  { path: '/settings', name: 'settings', meta: { title: 'Настройки' }, component: () => import('../views/SettingsView.vue') },
  { path: '/logs', name: 'logs', meta: { title: 'Журнал действий' }, component: () => import('../views/LogsView.vue') },
  { path: '/users', name: 'users', meta: { title: 'Пользователи', requiredRole: 'Admin' }, component: () => import('../views/UsersView.vue') },
  { path: '/users/:uid', name: 'userDetail', meta: { title: 'Пользователь', requiredRole: 'Admin' }, component: () => import('../views/UserDetailView.vue'), props: true },
  { path: '/applications', name: 'applications', meta: { title: 'Заявки' }, component: () => import('../views/ApplicationsView.vue') },
  { path: '/feedback', name: 'feedback', meta: { title: 'Обратная связь' }, component: () => import('../views/FeedbackView.vue') },
  { path: '/seo', name: 'seo', meta: { title: 'SEO', requiredRole: 'Admin' }, component: () => import('../views/SeoView.vue') },
  { path: '/pages/general', name: 'general', meta: { title: 'Общее' }, component: () => import('../views/pages/GeneralPageEditor.vue') },
  { path: '/pages/home', name: 'home', meta: { title: 'Главная' }, component: () => import('../views/pages/HomePageEditor.vue') },
  { path: '/pages/about', name: 'about', meta: { title: 'О нас' }, component: () => import('../views/pages/AboutPageEditor.vue') },
  { path: '/pages/courses', name: 'coursesPage', meta: { title: 'Страница курсов' }, component: () => import('../views/pages/CoursesPageEditor.vue') },
  { path: '/pages/events', name: 'eventsPage', meta: { title: 'Страница мероприятий' }, component: () => import('../views/pages/EventsPageEditor.vue') },
  { path: '/pages/blogs', name: 'blogsPage', meta: { title: 'Страница блога' }, component: () => import('../views/pages/BlogPageEditor.vue') },
  { path: '/pages/team', name: 'teamPage', meta: { title: 'Страница команды' }, component: () => import('../views/pages/TeamPageEditor.vue') },
  { path: '/pages/contacts', name: 'contacts', meta: { title: 'Контакты' }, component: () => import('../views/pages/ContactsPageEditor.vue') },
  { path: '/pages/profile', name: 'profile', meta: { title: 'Профиль' }, component: () => import('../views/pages/ProfilePageEditor.vue') },
  { path: '/pages/additional', name: 'additionalPages', meta: { title: 'Дополнительные страницы' }, component: () => import('../views/pages/AdditionalPagesEditor.vue') },
  { path: '/categories', name: 'categories', meta: { title: 'Категории' }, component: () => import('../views/CategoriesView.vue') },
  { path: '/collections/courses', name: 'courses', meta: { title: 'Курсы' }, component: () => import('../views/collections/CoursesListView.vue') },
  { path: '/collections/courses/:id', name: 'course', meta: { title: 'Курс' }, component: () => import('../views/collections/CourseEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) },
  { path: '/collections/started-courses', name: 'startedCourses', meta: { title: 'Запущенные курсы' }, component: () => import('../views/collections/StartedCoursesListView.vue') },
  { path: '/collections/started-courses/:id', name: 'startedCourse', meta: { title: 'Запущенный курс' }, component: () => import('../views/collections/StartedCourseEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) },
  { path: '/collections/test-bank', name: 'testBank', meta: { title: 'Банк тестов' }, component: () => import('../views/collections/TestBankListView.vue') },
  { path: '/collections/test-bank/:id', name: 'testBankItem', meta: { title: 'Тест' }, component: () => import('../views/collections/TestBankEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) },
  { path: '/collections/events', name: 'events', meta: { title: 'Мероприятия' }, component: () => import('../views/collections/EventsListView.vue') },
  { path: '/collections/events/:id', name: 'event', meta: { title: 'Мероприятие' }, component: () => import('../views/collections/EventEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) },
  { path: '/collections/blogs', name: 'blogs', meta: { title: 'Блог' }, component: () => import('../views/collections/BlogsListView.vue') },
  { path: '/collections/blogs/:id', name: 'blog', meta: { title: 'Статья' }, component: () => import('../views/collections/BlogEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) },
  { path: '/collections/team', name: 'team', meta: { title: 'Команда' }, component: () => import('../views/collections/TeamListView.vue') },
  { path: '/collections/team/:id', name: 'teamMember', meta: { title: 'Член команды' }, component: () => import('../views/collections/TeamMemberEditor.vue'), props: route => ({ itemId: route.params.id, draftId: route.query.id }) }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  }
})

router.beforeEach(async to => {
  await store.dispatch('initAuth')

  if (to.meta.public) {
    if (store.getters.isAuthenticated && to.name === 'login') return '/'
    return true
  }

  if (!store.getters.isAuthenticated) {
    return {
      path: '/login',
      query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
    }
  }

  if (to.meta.requiredRole === 'Admin' && !store.getters.isAdmin) {
    return '/categories'
  }

  return true
})

export default router
